(function () {
	'use strict';

	angular
		.module('sempraWebapp')
		.factory('OrganizationViewModel', organizationViewModelFactory);

	/** @ngInject */
	function organizationViewModelFactory() {
		function OrganizationViewModel() {
			this.organizationSearch = '';
			this.organizationTypeSearch = '';
			this.organizationTypes = [
				{
					name: 'All',
					value: ''
				},
				{
					name: 'Company',
					value: 'COMPANY'
				},
				{
					name: 'Region',
					value: 'REGION'
				},
				{
					name: 'Site',
					value: 'SITE'
				},
				{
					name: 'Self',
					value: 'SELF'
				}
			];
		}

		OrganizationViewModel.prototype.destroy = function () {};

		OrganizationViewModel.prototype.refresh = function (data) {
			this.organizationData = data;
		};

		return OrganizationViewModel;
	}
})();
